import { OnInit, ElementRef, Renderer, EventEmitter } from '@angular/core';
var CsModalComponent = /** @class */ (function () {
    function CsModalComponent(_hostRef, _renderer) {
        this._hostRef = _hostRef;
        this._renderer = _renderer;
        this.onOpen = new EventEmitter();
        this.onClose = new EventEmitter();
        this.isDisabledBackdrop = true;
    }
    CsModalComponent.prototype.ngOnInit = function () {
        // select2 field works in the form but not in a CsModalComponent! So resolved this with tabIndexValue
        if (typeof this.tabIndexValue == 'undefined') {
            this._renderer.setElementAttribute(this._hostRef.nativeElement, 'tabIndex', '-1');
        }
        else {
            if (!(this.tabIndexValue === '' || this.tabIndexValue === null)) {
                this._renderer.setElementAttribute(this._hostRef.nativeElement, 'tabIndex', this.tabIndexValue);
            }
        }
    };
    Object.defineProperty(CsModalComponent.prototype, "showModal", {
        set: function (show) {
            if (show && this.modalState !== 'open')
                this.open();
            else if (this.modalState !== 'closed')
                this.close();
        },
        enumerable: true,
        configurable: true
    });
    CsModalComponent.prototype.open = function () {
        var _this = this;
        jQuery(this._hostRef.nativeElement).appendTo("body").modal("show")
            .on('hide', function () {
            _this.onClose.emit();
        });
        if (this.isDisabledBackdrop) {
            jQuery('body').find('.modal-backdrop').off('click');
        }
        this.modalState = 'open';
        this.onOpen.emit();
    };
    CsModalComponent.prototype.close = function () {
        jQuery(this._hostRef.nativeElement).modal("hide");
        this.modalState = 'closed';
    };
    CsModalComponent.prototype.ngOnDestroy = function () {
        // Hide modal first so Bootstrap removes the backdrop, then remove the element
        try {
            jQuery(this._hostRef.nativeElement).modal('hide');
        }
        catch (_) { }
        jQuery(this._hostRef.nativeElement).remove();
    };
    return CsModalComponent;
}());
export { CsModalComponent };
